import SideBar from "../../components/sideBar/SideBar";
import DashboardInnerNavigator from "../../navigation/DashboardInnerNavigator";
import styles from "./dashBoardPage.module.css";

const DashboardPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sideBarContainer}>
        <SideBar />
      </div>
      <div className={styles.settingsContainer}>
        <DashboardInnerNavigator />
      </div>
    </div>
  );
};

export default DashboardPage;
